import PropTypes from 'prop-types'

import { Card, CardHeader } from 'lmcv/components/Card'
import { Icon } from 'lmcv/components/Icon'

import * as S from './styled'

function ModalError ({ title, message, onClose }) {
  return (
    <Card>
      <CardHeader title={title} text={message} />

      <S.ButtonClose onClick={onClose}>
        <Icon name="close_tiny" />
      </S.ButtonClose>

      <S.ButtonCloseText onClick={onClose}>
        <span>Fechar</span> <Icon name="close_tiny" />
      </S.ButtonCloseText>
    </Card>
  )
}

ModalError.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired
}

export default ModalError
